import { http } from '@/core/api/';
import circleAlertTypes from '@/utils/constants/student/circleAlertTypes.js';

const circleArray = [
  circleAlertTypes.CircleOne,
  circleAlertTypes.CircleTwo,
  circleAlertTypes.CircleThree,
  circleAlertTypes.CircleFour,
];

export default {
  async fetchAlerts() {
    const { data: response } = await http.get('api/alert');
    if (response) {
      let index = 0;
      return response.map((item) => {
        if (index >= circleArray.length) index = 0;
        item.type = circleArray[index];
        index++;
        return item;
      });
    }
  },
  /**
   *
   * @param { alertTypeId, PageSize, PageIndex } filters
   */
  async fetchAlertsByType(filters) {
    const { data: response } = await http.get(
      `api/alert/${filters.alertTypeId}`,
      {
        params: {
          pageIndex: filters.pageIndex,
          pageSize: filters.pageSize,
        },
      }
    );
    if (response) {
      return response;
    }
  },
  fetchMessages() {
    return http.get('api/message/mesaggefordashboard');
  },
  fetchSchedule(date, applicationId) {
    return http.get('api/calendarEvent/dailyevents/', {
      params: {
        date: date,
        applicationId,
      },
    });
  },
  saveReadMessage(messageId) {
    return http.post(`api/message/savemessageread/${messageId}`);
  },
  getEnrollmentCount() {
    return http.get('api/dashboard/enrollmentcount');
  },
  getEvents(params) {
    return http.get('api/dashboard/events', { params });
  },
  getWorkshops(params) {
    return http.get('api/dashboard/workshops', { params });
  },
  getNews() {
    return http.get('api/dashboard/news');
  },
  getEducationalMaterials(params) {
    return http.get('api/dashboard/educationalmaterials', { params });
  },
  getEducationalMaterialCategories() {
    return http.get('api/dashboard/educationalmaterials/categories');
  },
  getAlerts(params) {
    return http.get('api/dashboard/alerts', { params });
  },
  fetchUnreadMessages() {
    return http.get('api/dashboard/messagecount');
  },
  getTeachingMaterial(params) {
    return http.get('api/dashboard/teachingmaterial', { params });
  },
  markMessages(payload) {
    return http.post(`api/message/mark`, payload);
  },
  getGraphics() {
    return http.get('api/dashboard/graphics');
  },
  getGraphicByReportType(id) {
    return http.get(`api/dashboard/graphics/reportTypes/${id}`);
  },
  getSections() {
    return http.get(`api/dashboard/sections`);
  },
};
